export default __webpack_public_path__ + "static/media/theNewIndiaAssurance.5a72ade1.png";